import styled, { keyframes } from 'styled-components';
import { useNavigate } from 'react-router-dom';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const AboutContainer = styled.div`
  padding: 120px 50px 50px;
  min-height: 100vh;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  position: relative;

  @media (max-width: 768px) {
    padding: 100px 20px 30px;
  }
`;

const Content = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  animation: ${fadeIn} 1s ease-out;
`;

const Title = styled.h1`
  color: #1d3557;
  font-size: 2.5rem;
  margin-bottom: 30px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Section = styled.section`
  background: white;
  padding: 30px;
  border-radius: 10px;
  margin-bottom: 30px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  animation: ${fadeIn} 1s ease-out;
`;

const SectionTitle = styled.h2`
  color: #1d3557;
  font-size: 1.8rem;
  margin-bottom: 20px;
`;

const Text = styled.p`
  color: #333;
  line-height: 1.8;
  margin-bottom: 15px;
  font-size: 1.1rem;
`;

const Timeline = styled.div`
  margin: 30px 0;
  padding-left: 20px;
  border-left: 2px solid #1d3557;
`;

const TimelineItem = styled.div`
  margin-bottom: 30px;
  position: relative;
  padding-left: 30px;

  &:before {
    content: '';
    position: absolute;
    left: -11px;
    top: 0;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #1d3557;
  }
`;

const Year = styled.h3`
  color: #e63946;
  font-size: 1.3rem;
  margin-bottom: 10px;
`;

const ReturnButton = styled.button`
  position: fixed;
  top: 100px;
  left: 30px;
  background-color: #1d3557;
  color: white;
  border: none;
  border-radius: 25px;
  padding: 12px 25px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(0,0,0,0.2);
  font-weight: bold;
  z-index: 100;

  &:hover {
    transform: translateX(-3px);
    background-color: #e63946;
    box-shadow: 0 5px 15px rgba(0,0,0,0.3);
  }

  @media (max-width: 768px) {
    top: 90px;
    left: 20px;
    padding: 10px 20px;
  }
`;

const BackToTopButton = styled.button`
  position: fixed;
  bottom: 30px;
  right: 30px;
  background-color: #e63946;
  color: white;
  border: none;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(0,0,0,0.2);
  font-size: 20px;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 5px 15px rgba(0,0,0,0.3);
  }
`;

const About = () => {
  const navigate = useNavigate();

  const handleReturn = () => {
    navigate('/');
  };

  const handleBackToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <AboutContainer>
      <ReturnButton onClick={handleReturn}>
        ← Retour à l'accueil
      </ReturnButton>

      <Content>
        <Title>À Propos de New Malamba Business</Title>
        
        <Section>
          <SectionTitle>Notre Histoire</SectionTitle>
          <Text>
          Créés le 12 février 2007, les Établissements New Malamba Business se sont imposés 
          comme une référence incontournable en République Démocratique du Congo dans le 
          domaine de la papeterie et informatiques. Fort de près de deux décennies d'expérience, 
          notre société est animée par un engagement constant envers la qualité, l'innovation et 
          la satisfaction de nos clients.
          </Text>
        </Section>
        
        <Section>
        <Timeline>
        <TimelineItem>
          <SectionTitle>Notre Parcours</SectionTitle>
          </TimelineItem>            
          </Timeline>
              <Text>Depuis nos débuts, nous avons su développer une expertise qui repose sur une 
                connaissance approfondie du marché et une capacité à anticiper les besoins évolutifs des 
                entreprises et des particuliers. Grâce à nos prix compétitifs, nous attirons une clientèle
                fidèle. Chez New Malamba Business, nous croyons fermement que la qualité des 
                fournitures contribue directement à l'efficacité et à la réussite de nos clients.</Text>
        </Section>  

        <Section>
        <Timeline>
        <TimelineItem>
          <SectionTitle>Notre Vision</SectionTitle>
          </TimelineItem>            
          </Timeline>
          <Text>
            Notre vision c'est de devenir le partenaire de référence en papeterie, fournitures de
            bureau et solution infirmatique en République Democratique du Congo, en offrant a nos clients des 
            produits et services de qualité adaptés à leurs besoins.
            Nous aspirons a batir une entreprise durable et innonvante, contribuant a l'essorte du 
            secteur professionnel, educatif et technologie.
          </Text>
        </Section>

        <Section>
        <Timeline>
        <TimelineItem>
          <SectionTitle>Notre Mission</SectionTitle>
          </TimelineItem>            
          </Timeline>
          <Text>
            Notre mission est de fournir aux entreprises et aux particuliers des équipement fiable et accessible,
            en alliant excellence, inovation et proximité.
            Nous nous engageons a garantir la satisfaction client a travers une large game des produits,
            des conseils personnalisés et un service efficace.
          </Text>
        </Section>

        <Section>
        <Timeline>
        <TimelineItem>
          <SectionTitle>Nos Services</SectionTitle>
          </TimelineItem>            
          </Timeline>
          <Text>
            Papeteries et Fournitures de bureau (Papiers, Classeurs, Stylos, Marqueurs et 
            surligneurs effaçable, etc...)
          </Text>
          <Text>
            Consommables Informatiques (Toners, Imprimantes, Accessoirs IT).
          </Text>
          <Text>
            Equipement Technologique (Ordinateurs, Peripheriques, Logiciels).
          </Text>
          <Text>
            Conseils et accompagnement pour optimiser vos choix en matière d'équipements bureautique 
            et informatique.
          </Text>
          <Title>Bienvenues chez New Malamba Business!</Title>
        </Section>
      </Content>

      <BackToTopButton onClick={handleBackToTop}>↑</BackToTopButton>
    </AboutContainer>
  );
};

export default About;